
import TableList from "@components/templates/tablelist";
import { HttpPlanBillBoxing } from "@/service/allotment";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillBoxing,
    },
    computed: {
        columns() {
            return [
                {
                    title: 'ERP SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.alloment.qty', { defaultValue: '装箱数' }),
                    key: 'qty',
                },
                {
                    title: this.$t('fbb.inbound.case_code', { defaultValue: '箱码' }),
                    key: 'boxBarcode',
                },
                {
                    title: this.$t('fbb.alloment.tray_bar_code', { defaultValue: '托盘码' }),
                    key: 'trayBarcode',
                },
                {
                    title: this.$t('fbb.alloment.outer_box_weight', { defaultValue: '外箱毛重' }) + '（g）',
                    key: 'cartonGrossWeight',
                },
                {
                    title: this.$t('fbb.alloment.outer_box_size', { defaultValue: '外箱长*宽*高' }) + '（cm）',
                    key: 'cartonLength',
                    render(h, { row }) {
                        return <div>
                            {row.cartonLength}*
							{row.cartonWidth}*
							{row.cartonHeight}(cm*cm*cm)
							</div>
                    }
                }
            ];
        },

    },

};
